const blankToNull = require("./../../../utils").blankToNull;
const validateEmail = require("./../../../utils").validateEmail;
const { REGRA_SENHA, senhaAtendePolitica } = require("./../../../utils/politicaSenha");

export function validate(record) {
  blankToNull(record);
  const errors = [];
  if (!record.login || record.login.trim().length < 4) {
    errors.push({ field: "login", message: "O campo login é obrigatório e deve ter mais de 3 caracteres" });
  }

  // So vamos obrigar a senha em cadastro novo. Senha preenchida (nova ou trocada) segue a regra de complexidade
  // (PHOENIX-959). Vale para todo usuario desta tela: ela sempre grava como tipo EMPRESA (UsuarioFormPageContainer).
  const senha = record.senha ? record.senha.trim() : "";
  if (!record.oid && !senha) {
    errors.push({ field: "senha", message: "O campo senha é obrigatório. " + REGRA_SENHA });
  } else if (senha && !senhaAtendePolitica(senha)) {
    errors.push({ field: "senha", message: REGRA_SENHA });
  }

  if (record.email && record.email.trim().length > 0 && !validateEmail(record.email)) {
    errors.push({ field: "email", message: "O campo e-mail é inválido!" });
  }

  const result = {
    ok: errors.length === 0,
    errors,
    record
  };

  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject;
    return action(result);
  });
}
